import { ThreadReadStatus } from '@weave/schema-gen-ts/dist/schemas/sms/data/v4/sms_service.pb';
import { Direction, Status } from '@weave/schema-gen-ts/dist/schemas/sms/shared/v1/enums.pb';
import { ThreadReadStatus as UnifiedThreadReadStatus } from '@weave/schema-gen-ts/dist/schemas/sms/shared/v2/enums.pb';
import { Thread } from '@weave/schema-gen-ts/dist/schemas/sms/shared/v2/models.pb';
import { isSmsMessageItem } from '../../../utils/thread-items-utils';

/**
 * Returns the possible ThreadReadStatus values that this unified thread matches. If `undefined` is returned, it means that the
 * ThreadReadStatus cannot be determined from the thread, and should be based on its previous status.
 */
export const convertUnifiedThreadToApplicableThreadReadStatuses = (thread: Thread): ThreadReadStatus[] | undefined => {
  if (!thread.items?.length) {
    return undefined;
  }

  const result: ThreadReadStatus[] = [];

  // Find the newest SMS message from the items array
  const newestSmsItem = thread.items.find(isSmsMessageItem);
  if (!newestSmsItem?.smsMessage) {
    return undefined;
  }

  const newestMessage = newestSmsItem.smsMessage;

  const resolvedIsReplied =
    thread.isReplied || (newestMessage.direction === Direction.DIRECTION_OUTBOUND && !newestMessage.autogeneratedBy);
  const resolvedIsUnreplied =
    thread.isReplied === undefined ? newestMessage.direction === Direction.DIRECTION_INBOUND : !thread.isReplied;

  if (
    newestMessage.status === Status.STATUS_ERROR ||
    thread.status === UnifiedThreadReadStatus.THREAD_READ_STATUS_ERROR
  ) {
    result.push(ThreadReadStatus.ERROR);
  }
  if (thread.status === UnifiedThreadReadStatus.THREAD_READ_STATUS_NEW) result.push(ThreadReadStatus.NEW);
  if (thread.status === UnifiedThreadReadStatus.THREAD_READ_STATUS_READ) result.push(ThreadReadStatus.READ);
  if (resolvedIsReplied) result.push(ThreadReadStatus.REPLIED);
  if (resolvedIsUnreplied) result.push(ThreadReadStatus.UNREPLIED);

  if (!result.length) return undefined;
  return result;
};
